import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'authToken',
      'currentUser',
      'isAuthenticated',
      'isAuthenticatedAsAdmin',
    ]),
  },
};



// WEBPACK FOOTER //
// ./mixins/Authentication.js